import { Link } from "@tanstack/react-router";
import { SITE } from "@/lib/site";
import { PreferredSourceButton } from "@/components/site/PreferredSourceButton";

const NAV = [
  { to: "/", label: "Latest" },
  { to: "/category/$slug", params: { slug: "google-business-profile" }, label: "Business Profile" },
  { to: "/category/$slug", params: { slug: "google-maps" }, label: "Maps" },
  { to: "/category/$slug", params: { slug: "ai-search" }, label: "AI & Search" },
  { to: "/local-search-index", label: "Index" },
  { to: "/updates", label: "Updates" },
  { to: "/changelog", label: "Changelog" },
  { to: "/tools", label: "Tools" },
  { to: "/guide", label: "Guides" },
  { to: "/glossary", label: "Glossary" },
] as const;

export function SiteHeader() {
  return (
    <header className="border-b border-border bg-background">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-center justify-between py-2 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          <PreferredSourceButton
            placement="header"
            variant="inline"
            className="normal-case tracking-normal"
          />
          <span className="hidden sm:inline">For local SEO agencies & business owners</span>
          <span className="flex items-center gap-4">
            <Link to="/" hash="newsletter" className="hover:text-foreground transition-colors">
              Subscribe
            </Link>
          </span>
        </div>
        <div className="border-t border-border py-6 text-center">
          <Link to="/" className="inline-block" aria-label={`${SITE.name} — home`}>
            <span className="headline-display block text-4xl sm:text-6xl" aria-hidden>{SITE.name}</span>
            <span className="mt-2 block text-xs uppercase tracking-[0.28em] text-muted-foreground" aria-hidden>
              {SITE.tagline}
            </span>
          </Link>
        </div>
        <nav aria-label="Primary" className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 border-t border-border py-3 text-sm font-medium">
          {NAV.map((item) =>
            "params" in item ? (
              <Link
                key={item.label}
                to={item.to}
                params={item.params}
                className="text-foreground/80 hover:text-accent transition-colors"
                activeProps={{ className: "text-accent", "aria-current": "page" }}
              >
                {item.label}
              </Link>
            ) : (
              <Link
                key={item.label}
                to={item.to}
                className="text-foreground/80 hover:text-accent transition-colors"
                activeProps={{ className: "text-accent", "aria-current": "page" }}
                activeOptions={{ exact: true }}
              >
                {item.label}
              </Link>
            ),
          )}
        </nav>
      </div>
    </header>
  );
}
